module.exports = __webpack_public_path__ + "img/shipblu-upfront.768ed6d7.svg";